<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import netlifyApi from "@/services/useNetlifyFunctions";
import { titleFormatter, updateMetaTags } from "@/etc/utils/helpers";
import Block from "@components/redesign/Block/Block.vue";
import Loader from "@components/redesign/Loader/Loader.vue";

const route = useRoute();
const router = useRouter();
const loading = ref(true);

const blogPostSlug = computed(() => route.params.slug);
const dateString = computed(() => {
  if (post.value?.post_date) {
    return new Date(post.value.post_date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }
  return null;
});

const post = ref(null);

const fetchPost = async () => {
  try {
    const response = await netlifyApi.get("/woocommerce-post", {
      params: { slug: blogPostSlug.value },
    });

    if (response.data.length) {
      [post.value] = response.data;
      document.title = titleFormatter(post.value.post_title);

      const metaTags = [
        {
          name: "description",
          itemprop: "description",
          content: post.value.yoast_meta.meta_desc,
        },
        { property: "og:title", content: post.value.yoast_meta.seo_title },
        { name: "twitter:title", content: post.value.yoast_meta.seo_title },
        { name: "description", content: post.value.yoast_meta.meta_desc },
        {
          property: "og:description",
          content: post.value.yoast_meta.meta_desc,
        },
        {
          name: "twitter:description",
          content: post.value.yoast_meta.meta_desc,
        },
      ];

      updateMetaTags(document, metaTags);
    } else {
      router.push({ name: "NotFound" });
    }
  } catch (err) {
    router.push({ name: "NotFound" });
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  fetchPost();
});
</script>

<template>
  <Block header-spots-mobile="magenta-blue" header-spots-desktop="blue-gold">
    <div class="blog">
      <Loader v-if="loading" responsive="r-h3-to-h2" />

      <h1 class="r-h4-to-h2">{{ post?.post_title }}</h1>
      <span class="date r-h6-to-h5">{{ dateString }}</span>

      <div>
        <div v-if="loading" class="container fade-in-up">
          <h2 class="center">Loading</h2>
        </div>
      </div>

      <div class="blog-post">
        <div class="container">
          <div
            class="featured-image"
            :style="`background-image: url(${post?.featured_image});`"
            :alt="post?.post_title"
          ></div>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="post-content" v-html="post?.post_content"></div>
          <div class="hidden post-content">
            <figure class="wp-block-image">
              <img />
            </figure>
          </div>
        </div>
      </div>
    </div>
  </Block>
</template>

<style scoped src="./style.scss" lang="scss" />
<style scoped lang="scss">
.blog .blog-post figure {
  width: 100%;
  margin: 0 auto;
  height: auto;
  img {
    width: 100%;
    border-radius: 8px;
    height: auto;
  }
}
</style>
